import { takeLatest } from 'redux-saga/effects';
import * as types from './reducer';
import {getBlogArticlesSaga} from "./handler";

export default function* watchBlogArticles() {
    yield takeLatest(types.GET_BLOG_ARTICLES, getBlogArticlesSaga);
}
